/**
 * typescript doesn't infer return array to tuple automatically, use this function to get tuple type
 * https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-0.html#example-2
 * @param args
 */
export const tuple = <T extends any[]>(...args: T): T => args;
